import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdateOrderRequestSchema,
  TUpdateOrderResponseSchema,
} from "./updateOrder.schema";

export const updateOrder = (axios: IAxiosInstance) => {
  return async (data: TUpdateOrderRequestSchema) => {
    const response = await axios.noRetry.patch<
      IApiResponse<TUpdateOrderResponseSchema>
    >(`/orders`, data);

    return response.data;
  };
};
